import React, { useContext, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { Button, IconButton } from '@chakra-ui/react';
import { MdClose, MdOutlineWarning } from 'react-icons/md';
import { Icon } from '@chakra-ui/icon';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { ExperienceContext } from '../../lib/experienceContext';
import { useSharedExperiencesApi } from '../../../shared-experiences/lib/useSharedExperiencesApi';

export default function SharedExperienceInExperienceListItem({ sharedExperience, onRemove }) {
  const { rights, experienceId } = useContext(ExperienceContext);
  const [isRemoving, setIsRemoving] = useState(false);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const modalDelete = useDisclosure();

  const onTryToDeleteSharedExperience = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    modalDelete.onOpen();
  };

  const handleRemove = async () => {
    try {
      setIsRemoving(true);
      await sharedExperiencesApi.removeExperienceFromSharedExperience(
        sharedExperience.shared_experiences?.id || sharedExperience.id,
        experienceId
      );
      modalDelete.onClose();
      if (onRemove) {
        onRemove();
      }
    } catch (error) {
      console.error('Error removing shared experience:', error);
    } finally {
      setIsRemoving(false);
    }
  };

  const sharedExperienceData = sharedExperience.shared_experiences || sharedExperience;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="white"
      role="group"
      flex={1}
      mb={1}
      px={3}
      h="34px"
      _hover={{
        backgroundColor: 'background.grey',
        borderRadius: '2px'
      }}
    >
      <Flex alignItems="center">
        {/* Pas de logo/thumbnail pour les shared experiences */}
        <Text ml={0} fontSize="12px">
          {sharedExperienceData.name}
        </Text>
      </Flex>
      {rights.can_update && (
        <Box style={{ opacity: '0' }} _groupHover={{ opacity: '1 !important' }}>
          <IconButton
            icon={<MdClose />}
            size="md"
            aria-label="Remove"
            variant="greyTransparent"
            isLoading={isRemoving}
            onClick={onTryToDeleteSharedExperience}
          />
        </Box>
      )}
      <Modal isOpen={modalDelete.isOpen} onClose={modalDelete.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Remove shared experience {sharedExperienceData.name}</ModalHeader>
          <ModalBody p={3}>
            <Flex
              border="1px"
              borderColor="divider.grey"
              borderRadius="2px"
              backgroundColor="white"
              alignItems="center"
              p={3}
            >
              <Icon
                as={MdOutlineWarning}
                color="text.medium.red"
                boxSize="18px"
                mr={3}
              />
              <Text textStyle="body" color="text.medium.red">
                Are you sure to remove the shared experience {sharedExperienceData.name} from this experience?
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="redOutline"
              onClick={modalDelete.onClose}
            >
              Close
            </Button>
            <Button
              variant="redFill"
              ml={2}
              isLoading={isRemoving}
              onClick={handleRemove}
            >
              Remove
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
} 